exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "#asseco-survey-plugin,#asseco-survey .asseco-floaty-btn{background-color:#1976d2}", ""]);

// exports
